function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import WhatsNewPageLayoutComponent from "components/pages/whats-new/whats-new-page-layout-component";
import Error from "next/error";
import { getMondayConfig } from "/server/services/monday-service/monday-api-service";
import BaseTemplate from "components/templates/base-template";
import { getWhatsNewPageConfig } from "services/whats-new-page/whats-new-page-config-service";
import * as Sentry from "@sentry/nextjs";
import { staticMondayConfig } from "segments/desktop/embedded/layouts/whats-new-items-list-embedded/consts";
import { WHATS_NEW_GRAPHQL_COLUMN_IDS } from "components/pages/whats-new/consts";
import { createItemsArray } from "components/pages/whats-new/utils";
import BaseTemplatePage, { getServerSideProps as getBaseProps } from "../generated-templates/base-template-page";
const BOARD_ID = 3749556763;
const TITLE = "What's New - monday.com Product Updates";
const DESCRIPTION = "Find out what's new on monday.com products including feature releases, upgrades, and resources. Explore product updates by teams in a few clicks.";
export function getServerSideProps(context) {
    return _getServerSideProps.apply(this, arguments);
}
function _getServerSideProps() {
    _getServerSideProps = _async_to_generator(function*(context) {
        const baseProps = yield getBaseProps(context);
        const serverProps = baseProps.props;
        const query = `{
      boards(ids: ${BOARD_ID}) {
        items_page(limit: 500) {
          items {
            name
            column_values(ids: ${JSON.stringify(WHATS_NEW_GRAPHQL_COLUMN_IDS)}) {
              id
              value
            }
          }
        }
      }
    }`;
        context.res.statusCode = 200;
        try {
            const mondayConfig = yield getMondayConfig({
                query,
                boardId: BOARD_ID
            });
            return {
                props: _object_spread({
                    statusCode: context.res.statusCode,
                    mondayConfig
                }, serverProps)
            };
        } catch (e) {
            console.log(e.message);
            Sentry.setTag("page_locale", "whats-new");
            Sentry.captureException(`Monday api call for whats new page failed: ${e.message}`);
            context.res.statusCode = 500;
            return {
                props: {
                    statusCode: context.res.statusCode
                }
            };
        }
    });
    return _getServerSideProps.apply(this, arguments);
}
const filterLastYear = (array)=>{
    const now = new Date();
    const lastYearStart = new Date(now.getFullYear() - 1, now.getMonth(), 1);
    return array.filter((item)=>{
        const [month, year] = item.monthYearDate.split(" ");
        const date = new Date(`${month} 1, ${year}`); // Use day 1 for parsing
        return date >= lastYearStart;
    });
};
class WhatsNewPage extends BaseTemplatePage {
    render() {
        var _mondayConfigToUse_data_boards__items_page, _mondayConfigToUse_data_boards_, _mondayConfigToUse_data_boards, _mondayConfigToUse_data;
        const _this_props = this.props, { statusCode } = _this_props, props = _object_without_properties(_this_props, [
            "statusCode"
        ]);
        const { mondayConfig } = props, baseTemplateProps = _object_without_properties(props, [
            "mondayConfig"
        ]);
        if (statusCode !== 200) {
            return /*#__PURE__*/ _jsx(Error, {
                statusCode: statusCode
            });
        }
        const mondayConfigToUse = mondayConfig || staticMondayConfig;
        const items = mondayConfigToUse === null || mondayConfigToUse === void 0 ? void 0 : (_mondayConfigToUse_data = mondayConfigToUse.data) === null || _mondayConfigToUse_data === void 0 ? void 0 : (_mondayConfigToUse_data_boards = _mondayConfigToUse_data.boards) === null || _mondayConfigToUse_data_boards === void 0 ? void 0 : (_mondayConfigToUse_data_boards_ = _mondayConfigToUse_data_boards[0]) === null || _mondayConfigToUse_data_boards_ === void 0 ? void 0 : (_mondayConfigToUse_data_boards__items_page = _mondayConfigToUse_data_boards_.items_page) === null || _mondayConfigToUse_data_boards__items_page === void 0 ? void 0 : _mondayConfigToUse_data_boards__items_page.items;
        const itemsArrayObj = createItemsArray(items);
        const itemsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.itemsArray) || [];
        const itemsArrayLastYear = filterLastYear(itemsArray);
        const releaseHighlightsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.releaseHighlightsArray) || [];
        const monthlyVideosSet = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.monthlyVideosSet) || {};
        return /*#__PURE__*/ _jsx(BaseTemplate, _object_spread_props(_object_spread({}, baseTemplateProps, getWhatsNewPageConfig(), this.buildMetaTags()), {
            children: /*#__PURE__*/ _jsx(WhatsNewPageLayoutComponent, {
                itemsArray: itemsArrayLastYear,
                releaseHighlightsArray: releaseHighlightsArray,
                monthlyVideosSet: monthlyVideosSet
            })
        }));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "buildMetaTags", ()=>{
            return {
                title: TITLE,
                description: DESCRIPTION
            };
        });
    }
}
export { WhatsNewPage as default };
